import { BOPO_TYPES } from 'my-purchases/constants/bopoTypes'
import { ORDER_STATUS } from 'my-purchases/constants/orderStatus'
import { PAYMENT_TYPES } from 'my-purchases/constants/paymentTypes'

export const getBOPOKey = (
	status: ORDER_STATUS,
	paymentMethod?: PAYMENT_TYPES | null
) => {
	if (status === ORDER_STATUS.cancelled) {
		return paymentMethod === PAYMENT_TYPES.BOPO ? `.${BOPO_TYPES.bopo}` : ''
	}
	if (status === ORDER_STATUS.in_store) {
		return paymentMethod === PAYMENT_TYPES.BOPO
			? `.${BOPO_TYPES.bopo}`
			: `.${BOPO_TYPES.noBopo}`
	}
	return ''
}
